import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from 'components/CncUI/Typography';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    flexDirection: 'column',
  },
  progress: {
    padding: 15,
  },
  message: {
    padding: 15,
  },
}));

const Spinner = ({ message, variant, color = '#30aba3' }) => {
  const classes = useStyles();
  return (
    <div className={classes.root} id={`Spinner-root`}>
      <CircularProgress className={classes.progress} style={{ color }} />
      {message && (
        <Typography
          className={classes.message}
          variant={variant || 'body2'}
          id={`Spinner-message`}
        >
          {message}
        </Typography>
      )}
    </div>
  );
};

export default Spinner;
